module.exports = __webpack_public_path__ + "assets/526e871be00775819b732694e300354b.mp3";